import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'toggle', 'monthlyLabel', 'annualLabel',
    'monthlyPrice', 'annualPrice',
    'monthlyButton', 'annualButton'
  ]

  toggle () {
    const isAnnual = this.toggleTarget.checked

    this.showTargets(this.monthlyPriceTargets, !isAnnual)
    this.showTargets(this.annualPriceTargets, isAnnual)
    this.showTargets(this.monthlyButtonTargets, !isAnnual)
    this.showTargets(this.annualButtonTargets, isAnnual)

    this.monthlyLabelTarget.classList.toggle('opacity-40', isAnnual)
    this.annualLabelTarget.classList.toggle('opacity-40', !isAnnual)
  }

  showTargets (targets, visible) {
    targets.forEach(el => {
      if (visible) {
        el.style.display = ''
        el.classList.remove('hidden')
      } else {
        el.style.display = 'none'
      }
    })
  }
}
